module.exports = __webpack_public_path__ + "images/stickers/pete-ghost.fcb349d429bbaaf873ee.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/pete-ghost.png
// module id = i3YV
// module chunks = 1